function setStorage(key, value) {
  var isLocalStorage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  try {
    var storage = isLocalStorage ? window.localStorage : window.sessionStorage;
    storage.setItem(key, value);
  } catch (_unused) {
    // ignore this case
  }
}
function getStorage(key) {
  var isLocalStorage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  try {
    var storage = isLocalStorage ? window.localStorage : window.sessionStorage;
    return storage.getItem(key);
  } catch (_unused2) {
    // ignore this case
    return null;
  }
}
function removeStorage(key) {
  var isLocalStorage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  try {
    var storage = isLocalStorage ? window.localStorage : window.sessionStorage;
    storage.removeItem(key);
  } catch (_unused3) {
    // ignore this case
  }
}
function setObjectToLocalStorage(key, value) {
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch (_unused4) {
    // ignore this case
  }
}
function getObjectFromLocalStorage(key) {
  try {
    var obj = window.localStorage.getItem(key);
    return obj && JSON.parse(obj);
  } catch (_unused5) {
    // ignore this case
    return null;
  }
}

export { getObjectFromLocalStorage, getStorage, removeStorage, setObjectToLocalStorage, setStorage };
//# sourceMappingURL=index.js.map
